import apollo from '@/graphql'

import VendorsQuery from '@/graphql/vendor/VendorsQuery.gql'

// inital state
const state = {
  vendors: [],
}

// getters
const getters = {
  vendors: st => st.vendors,
}

// mutations
const mutations = {
  setVendors(st, vendors) {
    state.vendors = vendors
  },
}

// actions
const actions = {
  loadVendors({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: VendorsQuery,
    }).subscribe(({ data: { vendors } }) => {
      commit('setVendors', vendors)
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/vendor/VendorList.js